var __WEBPACK_NAMESPACE_OBJECT__ = Roo.locales['ar'];